import { render } from "./HomeMenuImageSorter.vue?vue&type=template&id=1b2109da&scoped=true"
import script from "./HomeMenuImageSorter.vue?vue&type=script&lang=js"
export * from "./HomeMenuImageSorter.vue?vue&type=script&lang=js"

import "./HomeMenuImageSorter.vue?vue&type=style&index=0&id=1b2109da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b2109da"

export default script